import script from "./StudentManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentManagement.vue?vue&type=script&setup=true&lang=js"

import "./StudentManagement.vue?vue&type=style&index=0&id=4b0e5784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0e5784"]])

export default __exports__